import type { Preset } from '../types/index.js';
import type { PresetConfig } from './node-api.js';
import { nodeApiPreset } from './node-api.js';
import { nextjsAppPreset } from './nextjs-app.js';

export type { PresetConfig };

export const presets: Record<Preset, PresetConfig> = {
  'node-api': nodeApiPreset,
  'nextjs-app': nextjsAppPreset,
  'python-api': nodeApiPreset, // TODO: implement
  'cli-tool': nodeApiPreset, // TODO: implement
  library: nodeApiPreset, // TODO: implement
  monorepo: nodeApiPreset, // TODO: implement
};

export function getPreset(name: Preset): PresetConfig {
  const preset = presets[name];
  if (!preset) {
    throw new Error(`Unknown preset: ${name}`);
  }
  return preset;
}

export function listPresets(): Preset[] {
  return Object.keys(presets) as Preset[];
}
